import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Plus, Trash2 } from "lucide-react";

export default function AdminCategoriesPage() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ type: "journal", name_tr: "", name_en: "", description_tr: "" });

  const load = async () => {
    const { data } = await api.get("/admin/categories");
    setItems(data || []);
  };
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!form.name_tr) return;
    await api.post("/admin/categories", {
      type: form.type,
      translations: {
        tr: { name: form.name_tr, description: form.description_tr },
        en: { name: form.name_en, description: "" },
      },
    });
    setForm({ type: "journal", name_tr: "", name_en: "", description_tr: "" });
    load();
  };

  const del = async (id) => {
    if (!window.confirm("Silinsin mi?")) return;
    await api.delete(`/admin/categories/${id}`);
    load();
  };

  return (
    <div data-testid="admin-categories">
      <h1 className="font-serif text-4xl text-cc-text mb-2">Kategoriler</h1>
      <p className="text-sm text-cc-muted mb-8">Journal ve Rehber kategorileri</p>

      <form onSubmit={add} className="bg-white border border-admin-border p-5 mb-8 grid md:grid-cols-5 gap-3 items-end" data-testid="cat-form">
        <label className="text-xs text-cc-muted">
          Tür
          <select value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })} className="cc-input mt-1">
            <option value="journal">Journal</option><option value="guide">Rehber</option>
          </select>
        </label>
        <label className="text-xs text-cc-muted">Ad (TR) <input value={form.name_tr} onChange={(e) => setForm({ ...form, name_tr: e.target.value })} className="cc-input" /></label>
        <label className="text-xs text-cc-muted">Ad (EN) <input value={form.name_en} onChange={(e) => setForm({ ...form, name_en: e.target.value })} className="cc-input" /></label>
        <label className="text-xs text-cc-muted">Açıklama <input value={form.description_tr} onChange={(e) => setForm({ ...form, description_tr: e.target.value })} className="cc-input" /></label>
        <button className="cc-btn text-[10px] py-2"><Plus size={14} /> Ekle</button>
      </form>

      <div className="bg-white border border-admin-border">
        <table className="w-full text-sm">
          <thead className="bg-admin-bg/60 text-left">
            <tr><th className="px-4 py-3 text-[10px] uppercase tracking-overline text-cc-muted">Ad</th>
                <th className="px-4 py-3 text-[10px] uppercase tracking-overline text-cc-muted">Tür</th>
                <th className="px-4 py-3 text-[10px] uppercase tracking-overline text-cc-muted">Slug</th>
                <th></th></tr>
          </thead>
          <tbody>
            {items.map((c) => (
              <tr key={c.id} className="border-t border-admin-border">
                <td className="px-4 py-3">{c.translations?.tr?.name}</td>
                <td className="px-4 py-3 text-cc-muted">{c.type}</td>
                <td className="px-4 py-3 text-cc-muted font-mono text-xs">{c.translations?.tr?.slug}</td>
                <td className="px-4 py-3 text-right"><button onClick={() => del(c.id)} className="text-cc-muted hover:text-red-600"><Trash2 size={14} /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
